const body = document.getElementsByTagName('body')[0];

export default {
	images: `${body.dataset.root}/themes/${body.dataset.theme}/images/`,
	components: `${body.dataset.root}/themes/${body.dataset.theme}/components/`,
	assets: `${body.dataset.root}/themes/${body.dataset.theme}/assets/`
}
    


// WEBPACK FOOTER //
// ./js/core/Helpers/Paths.js